// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { PharmacyGroupDrug } from '../_models/pharmacy-group-drug.model';
// Models
import { QueryParamsModel } from '../../_base/crud';

export enum PharmacyGroupDrugActionTypes {
  AllPharmacyGroupDrugsRequested = '[PharmacyGroupDrugs] All PharmacyGroupDrugs Requested',
  AllPharmacyGroupDrugsLoaded = '[PharmacyGroupDrugs] All PharmacyGroupDrugs Loaded',
  AddPharmacyGroupDrugs = '[PharmacyGroupDrugs] Add PharmacyGroupDrugs',
  PharmacyGroupDrugOnServerUpdated = '[PharmacyGroupDrugs] PharmacyGroupDrug On Server Updated',
  PharmacyGroupDrugUpdated = '[PharmacyGroupDrugs] PharmacyGroupDrug Updated',
  PharmacyGroupDrugStoreUpdated = '[PharmacyGroupDrugs] PharmacyGroupDrug Store Updated',
  PharmacyGroupDrugOnServerDeleted = '[PharmacyGroupDrugs] PharmacyGroupDrug On Server Deleted',
  PharmacyGroupDrugDeleted = '[PharmacyGroupDrugs] PharmacyGroupDrug Deleted',
  PharmacyGroupDrugsPageRequested = '[PharmacyGroupDrugs] PharmacyGroupDrugs Page Requested',
  PharmacyGroupDrugsPageLoaded = '[PharmacyGroupDrugs] PharmacyGroupDrugs Page Loaded',
  PharmacyGroupDrugsPageCancelled = '[PharmacyGroupDrugs] PharmacyGroupDrugs Page Cancelled',
  PharmacyGroupDrugsPageToggleLoading = '[PharmacyGroupDrugs] PharmacyGroupDrugs Page Toggle Loading',
  PharmacyGroupDrugsActionToggleLoading = '[PharmacyGroupDrugs] PharmacyGroupDrugs Action Toggle Loading',
  ThrowPharmacyGroupDrugError = '[PharmacyGroupDrugs] Throw Error',
  FirePharmacyGroupDrugSuccess = '[PharmacyGroupDrugs] Fire Success',
  ClearPharmacyGroupDrugState = '[PharmacyGroupDrugs] Clear PharmacyGroupDrug State',
}

export class AddPharmacyGroupDrugs implements Action {
  readonly type = PharmacyGroupDrugActionTypes.AddPharmacyGroupDrugs;
  constructor(public payload: { drugs: Array<{ id }>; pharmacyGroupId: number }) {}
}

export class ThrowPharmacyGroupDrugError implements Action {
  readonly type = PharmacyGroupDrugActionTypes.ThrowPharmacyGroupDrugError;
  constructor(public payload: { error: any }) {}
}

export class FirePharmacyGroupDrugSuccess implements Action {
  readonly type = PharmacyGroupDrugActionTypes.FirePharmacyGroupDrugSuccess;
  constructor(public payload: { action_type: string }) {}
}

export class PharmacyGroupDrugOnServerUpdated implements Action {
  readonly type = PharmacyGroupDrugActionTypes.PharmacyGroupDrugOnServerUpdated;
  constructor(
    public payload: {
      pharmacyGroupId: number;
      partialPharmacyGroupDrug: Update<PharmacyGroupDrug>;
      pharmacyGroupDrug: PharmacyGroupDrug;
    },
  ) {}
}
export class PharmacyGroupDrugUpdated implements Action {
  readonly type = PharmacyGroupDrugActionTypes.PharmacyGroupDrugUpdated;
  constructor(
    public payload: {
      partialPharmacyGroupDrug: Update<PharmacyGroupDrug>;
      pharmacyGroupDrug: PharmacyGroupDrug;
    },
  ) {}
}

export class PharmacyGroupDrugStoreUpdated implements Action {
  readonly type = PharmacyGroupDrugActionTypes.PharmacyGroupDrugStoreUpdated;

  constructor(
    public payload: {
      pharmacyGroupDrug: Update<PharmacyGroupDrug>; // For State update
    },
  ) {}
}

export class PharmacyGroupDrugOnServerDeleted implements Action {
  readonly type = PharmacyGroupDrugActionTypes.PharmacyGroupDrugOnServerDeleted;
  constructor(public payload: { id: number; pharmacyGroupId: number }) {}
}

export class PharmacyGroupDrugDeleted implements Action {
  readonly type = PharmacyGroupDrugActionTypes.PharmacyGroupDrugDeleted;
  constructor(public payload: { id: number }) {}
}

export class PharmacyGroupDrugsPageRequested implements Action {
  readonly type = PharmacyGroupDrugActionTypes.PharmacyGroupDrugsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class PharmacyGroupDrugsPageLoaded implements Action {
  readonly type = PharmacyGroupDrugActionTypes.PharmacyGroupDrugsPageLoaded;
  constructor(
    public payload: {
      pharmacyGroupDrugs: PharmacyGroupDrug[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class PharmacyGroupDrugsPageCancelled implements Action {
  readonly type = PharmacyGroupDrugActionTypes.PharmacyGroupDrugsPageCancelled;
}

export class PharmacyGroupDrugsPageToggleLoading implements Action {
  readonly type = PharmacyGroupDrugActionTypes.PharmacyGroupDrugsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class PharmacyGroupDrugsActionToggleLoading implements Action {
  readonly type = PharmacyGroupDrugActionTypes.PharmacyGroupDrugsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ClearPharmacyGroupDrugState implements Action {
  readonly type = PharmacyGroupDrugActionTypes.ClearPharmacyGroupDrugState;
}

export type PharmacyGroupDrugActions =
  | AddPharmacyGroupDrugs
  | PharmacyGroupDrugUpdated
  | PharmacyGroupDrugDeleted
  | PharmacyGroupDrugOnServerUpdated
  | PharmacyGroupDrugOnServerDeleted
  | PharmacyGroupDrugStoreUpdated
  | PharmacyGroupDrugsPageLoaded
  | PharmacyGroupDrugsPageCancelled
  | PharmacyGroupDrugsPageToggleLoading
  | PharmacyGroupDrugsPageRequested
  | ThrowPharmacyGroupDrugError
  | FirePharmacyGroupDrugSuccess
  | PharmacyGroupDrugsActionToggleLoading
  | ClearPharmacyGroupDrugState;
